import PurchaseBusinessService from '../../purchase-business-service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import {purchaseProjectStatus} from '@/utils/mixins/purchase-project-status';
import { changeSkin } from '@/utils/common.js';
import Payment from '@/components/payment/payment.vue';
import updateBankMixins from '@/utils/mixins/update-bank-mixins.js';
import ApplyRevocation from '@/components/apply-revocation/index.vue';

export default {
  mixins: [updateBankMixins, purchaseProjectStatus],
  components: {
    Pagination,
    Payment,
    ApplyRevocation
  },
  data() {
    return {
      currentProjectId: '',
      signApproveStatus: [],
      total: 0,
      tableList: [],
      date: [],
      searchForm: {
        projectName: '',
        status: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 5
      },
      showPayment: false,
      actionId: '',
      applyReparams: {
        dialogVisible: false,
        bidId: '',
        phone: ''
      }
    };
  },
  created() {
    const arr = [
      ['signApproveStatus', 'PURCHASE_SIGN_APPROVE_STATUS']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = [{code: '', value: '全部'}, ...res.data];
        }
      });
    });
    this.getSignUpPurchaseList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    // 申请撤销
    applyRevocation (item) {
      this.applyReparams = {
        dialogVisible: true,
        bidId: item.bidId,
        phone: item.technicalDirectorPhone
      };
    },
    // 撤销报名
    revocationSignUp (item) {
      let that = this;
      that.$confirm('您将撤销报名信息，是否重新报名?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        distinguishCancelAndClose: true,
        type: 'warning',
        beforeClose: (action, instance, done) => {
          console.dir(instance);
          if (action !== 'close') {
            PurchaseBusinessService.revocationSignUp(item.bidId).then(({ code }) => {
              if (code === '0') {
                // 选择是 则跳转到报名页面
                if (action === 'confirm') {
                  that.$router.push({ path: '/collective-purchasing/sign-up', query: {
                    id: item.purchaseId,
                    purchaseType: item.purchaseType,
                    promiseEnterprise: item.promiseEnterprise,
                    criminalRecord: item.criminalRecord,
                    qualificationReview: item.qualificationReview,
                    relationId: item.relationId
                  }});
                } else {
                  that.$successMessage('已撤销报名，您还可以重新报名');
                  that.getSignUpPurchaseList();
                }
              }
            }).catch((error) => {
              if (error && error.data && error.data.reason) {
                this.$errorMessage(error.data.reason);
              } else {
                this.$errorMessage('撤销失败');
              }
            });
          }
          done();
        }
      });
    },
    // 获取我的报名采购标的列表
    getSignUpPurchaseList(page){
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      PurchaseBusinessService.getSignUpPurchaseList(this.searchForm).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
          this.tableList.forEach(item => {
            if((item.status > 60 && item.status <= 62) || (item.status >= 50 && item.status <= 55)){
              item.status = 50;// 报名成功的状态
            }
          });
        }
      });
    },
    getProjectType (type) {
      if (type === 1) {
        return require('@/assets/images/common/engineering1.jpg');
      } else if (type === 2) {
        return require('@/assets/images/common/goods1.jpg');
      } else {
        return require('@/assets/images/common/service1.jpg');
      }
    },
    goToDetail (item) {
      window.open(window.location.origin + '/#/collective-purchasing/detail?id=' + item.purchaseId);
    },
    onChangeDate (event) {
      this.searchForm.startTime = event && event[0];
      this.searchForm.endTime = event && event[1];
    },
    clear () {
      this.searchForm = {
        projectName: '',
        status: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 5
      };
      this.date = [];
      this.getSignUpPurchaseList();
    },
    btnText (status) {
      if (status === 10 || status === 30) {
        return '支付';
      }
      // 待填写报名材料
      if (status === 21) {
        return '填写报名材料';
      }
    },
    btnAction (item) {
      if (item.status === 10) {
        this.actionId = item.purchaseId;
        this.showPayment = true;
      } else if (item.status === 30) {
        this.$router.push('/person-center/purchase-business/sign-up-purchase/margin-payment?id=' + item.bidId + '&bidSignRelationId=' + item.relationId);
      } else if(item.status === 21) {
        this.$router.push(`/collective-purchasing/sign-up?id=${item.purchaseId}&purchaseType=${item.purchaseType}&promiseEnterprise=${item.promiseEnterprise}&criminalRecord=${item.promiseEnterprise}&qualificationReview=${item.qualificationReview}`);
        // console.log('--------跳转到申请报名');
      }
    },
    goToSignUpDetail (item) {
      this.$router.push('/person-center/purchase-business/sign-up-purchase/detail?id=' + item.relationId);
    },
    paymentSuccess () {
      this.getSignUpPurchaseList();
    }
  }
};
